(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNavigationBreakpoint extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.shopify-section');
      this.desktopQuery = window.matchMedia('(min-width: 1366px)');
      this.onBreakpointChange = (event) => {
        if (!event.matches) return;
        const drawer = this.header.querySelector('header-drawer');
        const details = drawer && drawer.querySelector('details');
        if (!details || !details.open || typeof drawer.closeMenuDrawer !== 'function') return;
        const target = this.header.querySelector('.header__inline-menu a, .header__inline-menu summary');
        drawer.closeMenuDrawer(event, target);
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
      };
      this.desktopQuery.addEventListener('change', this.onBreakpointChange);
    }

    disconnectedCallback() {
      if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
    }
  }
  customElements.define('header-navigation-breakpoint', HeaderNavigationBreakpoint);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // ResizeObserver supplies the first laid-out size before paint. Reading
      // offsetHeight here forced the whole page to lay out during script startup.
      if (typeof ResizeObserver === 'function') {
        this.headerResizeObserver = new ResizeObserver((entries) => {
          if (!this.isConnected) return;
          const entry = entries[0];
          const box = entry.borderBoxSize;
          const borderBox = box && (box[0] || box);
          this.setHeaderHeight(borderBox && borderBox.blockSize);
        });
        this.headerResizeObserver.observe(this.header, { box: 'border-box' });
      } else {
        this.setHeaderHeight();
        this.headerHeightHandler = this.setHeaderHeight.bind(this);
        this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
        if (this.headerMediaQuery.addEventListener) {
          this.headerMediaQuery.addEventListener('change', this.headerHeightHandler);
        } else {
          this.headerMediaQuery.addListener(this.headerHeightHandler);
        }
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight(observedHeight) {
      const height = Math.round(typeof observedHeight === 'number' ? observedHeight : this.header.offsetHeight);
      if (height === this.headerHeight) return;
      this.headerHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      if (this.headerBoundsObserver) this.headerBoundsObserver.disconnect();
      if (this.headerMediaQuery) {
        if (this.headerMediaQuery.removeEventListener) {
          this.headerMediaQuery.removeEventListener('change', this.headerHeightHandler);
        } else {
          this.headerMediaQuery.removeListener(this.headerHeightHandler);
        }
      }
    }

    createObserver() {
      this.headerBoundsObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerBoundsObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
